module.exports = __webpack_public_path__ + "img/pigai-order.f022b051.png";